import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Classes, EditorSubElements } from "@/types";
import { getBreakpoint, getBreakpointClasses } from "@/utils";
import { nextTick, onBeforeUnmount, onMounted, PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditorWrapper',
  props: {
  value: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Object,
    default: () => ({
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          //["blockquote", "code-block"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          /*[{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ font: [] }],
          [{ align: [] }],*/
          ["clean"],
        ],
      },
      placeholder: false,
      theme: "snow",
    }),
  },
  classes: Object as PropType<Classes<EditorSubElements>>,
},
  emits: ["update:value"],
  setup(__props) {

const props = __props;

const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};




const breakpoint = ref(getBreakpoint(window.innerWidth));

if (props.classes?.editor != undefined) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_quill_editor = _resolveComponent("quill-editor")!

  return (_openBlock(), _createBlock(_component_quill_editor, {
    disabled: __props.disabled,
    options: __props.options,
    value: __props.value,
    class: _normalizeClass(_unref(getBreakpointClasses)(__props.classes?.editor, breakpoint.value)),
    onChange: _cache[0] || (_cache[0] = ($event) => _ctx.$emit('update:value', $event.html))
  }, null, 8, ["disabled", "options", "value", "class"]))
}
}

})